
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('backend/html5fs',["require", "exports", '../generic/preload_file', '../core/file_system', '../core/api_error', '../core/file_flag', '../core/node_fs_stats', '../core/buffer', '../core/browserfs', '../core/buffer_core_arraybuffer', "../../vendor/async/lib/async"], function(require, exports, preload_file, file_system, api_error, file_flag, node_fs_stats, buffer, browserfs, buffer_core_arraybuffer) {
    var Buffer = buffer.Buffer;
    var Stats = node_fs_stats.Stats;
    var FileType = node_fs_stats.FileType;
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var ActionType = file_flag.ActionType;

    var async = require('../../vendor/async/lib/async');

    var _getFS = window.webkitRequestFileSystem || window.requestFileSystem || null;

    function _requestQuota(type, size, success, errorCallback) {
        if (typeof navigator['webkitPersistentStorage'] !== 'undefined') {
            switch (type) {
                case window.PERSISTENT:
                    navigator.webkitPersistentStorage.requestQuota(size, success, errorCallback);
                    break;
                case window.TEMPORARY:
                    navigator.webkitTemporaryStorage.requestQuota(size, success, errorCallback);
                    break;
                default:
                    errorCallback(null);
                    break;
            }
        } else {
            window.webkitStorageInfo.requestQuota(type, size, success, errorCallback);
        }
    }

    function _toArray(list) {
        return Array.prototype.slice.call(list || [], 0);
    }

    var HTML5FSFile = (function (_super) {
        __extends(HTML5FSFile, _super);
        function HTML5FSFile(_fs, _path, _flag, _stat, contents) {
            _super.call(this, _fs, _path, _flag, _stat, contents);
        }
        HTML5FSFile.prototype.sync = function (cb) {
            var self = this;

            var opts = {
                create: false
            };
            var _fs = this._fs;
            var success = function (entry) {
                entry.createWriter(function (writer) {
                    var buffer = self._buffer;
                    var backing_mem = self._buffer.getBufferCore();
                    if (!(backing_mem instanceof buffer_core_arraybuffer.BufferCoreArrayBuffer)) {
                        buffer = new Buffer(self._buffer.length);
                        self._buffer.copy(buffer);
                        backing_mem = buffer.getBufferCore();
                    }

                    var dv = backing_mem.getDataView();

                    var abv = new DataView(dv.buffer, dv.byteOffset + buffer.getOffset(), buffer.length);
                    var blob = new Blob([abv]);
                    var length = blob.size;
                    writer.onwriteend = function (event) {
                        writer.onwriteend = null;
                        writer.truncate(length);
                        cb();
                    };
                    writer.onerror = function (err) {
                        cb(_fs.convert(err));
                    };
                    writer.write(blob);
                });
            };
            var error = function (err) {
                cb(_fs.convert(err));
            };
            _fs.fs.root.getFile(this._path, opts, success, error);
        };

        HTML5FSFile.prototype.close = function (cb) {
            this.sync(cb);
        };
        return HTML5FSFile;
    })(preload_file.PreloadFile);
    exports.HTML5FSFile = HTML5FSFile;

    var HTML5FS = (function (_super) {
        __extends(HTML5FS, _super);
        function HTML5FS(size, type) {
            _super.call(this);
            this.size = size != null ? size : 5;
            this.type = type != null ? type : window.PERSISTENT;
            var kb = 1024;
            var mb = kb * kb;
            this.size *= mb;
        }
        HTML5FS.prototype.getName = function () {
            return 'HTML5 FileSystem';
        };

        HTML5FS.isAvailable = function () {
            return _getFS != null;
        };

        HTML5FS.prototype.isReadOnly = function () {
            return false;
        };

        HTML5FS.prototype.supportsSymlinks = function () {
            return false;
        };

        HTML5FS.prototype.supportsProps = function () {
            return false;
        };

        HTML5FS.prototype.supportsSynch = function () {
            return false;
        };

        HTML5FS.prototype.convert = function (err, message) {
            if (typeof message === "undefined") { message = ""; }
            switch (err.name) {
                case 'QuotaExceededError':
                    return new ApiError(11 /* ENOSPC */, message);
                case 'NotFoundError':
                    return new ApiError(1 /* ENOENT */, message);
                case 'SecurityError':
                    return new ApiError(4 /* EACCES */, message);
                case 'SyntaxError':
                case 'TypeMismatchError':
                    return new ApiError(9 /* EINVAL */, message);
                default:
                    console.log("Unknown Error: " + err.name);
                    return new ApiError(9 /* EINVAL */, message);
            }
        };

        HTML5FS.prototype.convertErrorEvent = function (err, message) {
            if (typeof message === "undefined") { message = ""; }
            return new ApiError(1 /* ENOENT */, err.message + "; " + message);
        };

        HTML5FS.prototype.allocate = function (cb) {
            if (typeof cb === "undefined") { cb = function () {
            }; }
            var self = this;
            var success = function (fs) {
                self.fs = fs;
                cb();
            };
            var error = function (err) {
                cb(self.convert(err));
            };
            if (this.type === window.PERSISTENT) {
                _requestQuota(this.type, this.size, function (granted) {
                    _getFS(this.type, granted, success, error);
                }, error);
            } else {
                _getFS(this.type, this.size, success, error);
            }
        };

        HTML5FS.prototype.empty = function (main_cb) {
            var self = this;

            self._readdir('/', function (err, entries) {
                if (err) {
                    console.error('Failed to empty FS');
                    main_cb(err);
                } else {
                    var finished = function (er) {
                        if (err) {
                            console.error("Failed to empty FS");
                            main_cb(err);
                        } else {
                            main_cb();
                        }
                    };

                    var deleteEntry = function (entry, cb) {
                        var succ = function () {
                            cb();
                        };
                        var error = function (err) {
                            cb(self.convert(err, entry.fullPath));
                        };
                        if (entry.isFile) {
                            entry.remove(succ, error);
                        } else {
                            entry.removeRecursively(succ, error);
                        }
                    };

                    async.each(entries, deleteEntry, finished);
                }
            });
        };

        HTML5FS.prototype.rename = function (oldPath, newPath, cb) {
            var self = this;
            var success = function (file) {
                file.moveTo(oldPath, newPath);
                cb();
            };
            var error = function (err) {
                cb(self.convert(err, "Failed to rename " + oldPath + " to " + newPath + "."));
            };
            this.fs.root.getFile(oldPath, {}, success, error);
        };

        HTML5FS.prototype.stat = function (path, isLstat, cb) {
            var self = this;

            var opts = {
                create: false
            };

            var loadAsFile = function (entry) {
                var fileFromEntry = function (file) {
                    var stat = new Stats(32768 /* FILE */, file.size);
                    cb(null, stat);
                };
                entry.file(fileFromEntry, failedToLoad);
            };

            var loadAsDir = function (dir) {
                var size = 4096;
                var stat = new Stats(16384 /* DIRECTORY */, size);
                cb(null, stat);
            };

            var failedToLoad = function (err) {
                cb(self.convert(err, path));
            };

            var failedToLoadAsFile = function () {
                self.fs.root.getDirectory(path, opts, loadAsDir, failedToLoad);
            };

            this.fs.root.getFile(path, opts, loadAsFile, failedToLoadAsFile);
        };

        HTML5FS.prototype.open = function (path, flags, mode, cb) {
            var self = this;
            var opts = {
                create: flags.pathNotExistsAction() === 3 /* CREATE_FILE */,
                exclusive: flags.isExclusive()
            };
            var error = function (err) {
                cb(self.convertErrorEvent(err, path));
            };
            var error2 = function (err) {
                cb(self.convert(err, path));
            };
            var success = function (entry) {
                var success2 = function (file) {
                    var reader = new FileReader();
                    reader.onloadend = function (event) {
                        var bfs_file = self._makeFile(path, flags, file, reader.result);
                        cb(null, bfs_file);
                    };
                    reader.onerror = error;
                    reader.readAsArrayBuffer(file);
                };
                entry.file(success2, error2);
            };
            this.fs.root.getFile(path, opts, success, error);
        };

        HTML5FS.prototype._statType = function (stat) {
            return stat.isFile ? 32768 /* FILE */ : 16384 /* DIRECTORY */;
        };

        HTML5FS.prototype._makeFile = function (path, flag, stat, data) {
            if (typeof data === "undefined") { data = new ArrayBuffer(0); }
            var stats = new Stats(32768 /* FILE */, stat.size);
            var buffer = new Buffer(data);
            return new HTML5FSFile(this, path, flag, stats, buffer);
        };

        HTML5FS.prototype._remove = function (path, cb, isFile) {
            var self = this;
            var success = function (entry) {
                var succ = function () {
                    cb();
                };
                var err = function (err) {
                    cb(self.convert(err, path));
                };
                entry.remove(succ, err);
            };
            var error = function (err) {
                cb(self.convert(err, path));
            };

            var opts = {
                create: false
            };

            if (isFile) {
                this.fs.root.getFile(path, opts, success, error);
            } else {
                this.fs.root.getDirectory(path, opts, success, error);
            }
        };

        HTML5FS.prototype.unlink = function (path, cb) {
            this._remove(path, cb, true);
        };

        HTML5FS.prototype.rmdir = function (path, cb) {
            this._remove(path, cb, false);
        };

        HTML5FS.prototype.mkdir = function (path, mode, cb) {
            var self = this;

            var opts = {
                create: true,
                exclusive: true
            };
            var success = function (dir) {
                cb();
            };
            var error = function (err) {
                cb(self.convert(err, path));
            };
            this.fs.root.getDirectory(path, opts, success, error);
        };

        HTML5FS.prototype._readdir = function (path, cb) {
            var self = this;
            var reader = this.fs.root.createReader();
            var entries = [];
            var error = function (err) {
                cb(self.convert(err, path));
            };

            var readEntries = function () {
                reader.readEntries((function (results) {
                    if (results.length) {
                        entries = entries.concat(_toArray(results));
                        readEntries();
                    } else {
                        cb(null, entries);
                    }
                }), error);
            };
            readEntries();
        };

        HTML5FS.prototype.readdir = function (path, cb) {
            this._readdir(path, function (e, entries) {
                if (e != null) {
                    return cb(e);
                }
                var rv = [];
                for (var i = 0; i < entries.length; i++) {
                    rv.push(entries[i].name);
                }
                cb(null, rv);
            });
        };
        return HTML5FS;
    })(file_system.BaseFileSystem);
    exports.HTML5FS = HTML5FS;

    browserfs.registerFileSystem('HTML5FS', HTML5FS);
});
//# sourceMappingURL=html5fs.js.map
;